import React from "react";

import styles from "./index.module.scss";

const ArticleGrid: React.FC = (props) => {
  const { children } = props;

  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  const cards = React.Children.map(children, (card: any, i) => {
    return (
      <div className={styles.card} key={i}>
        {card}
      </div>
    );
  });

  return <div className={styles.container}>{cards}</div>;
};

export { ArticleGrid };
